
(function () {
    'use strict';
    angular.module('core')
        .controller('BaseController', BaseController);

    BaseController.$inject = ['$scope', '$location', 'DataService', '$rootScope', 'editService', 'ArcGISMap', 'userService', '$filter', 'dataConfigService', 'keycloakService', 'serviceBase'];
    function BaseController($scope, $location, DataService, $rootScope, editService, ArcGISMap, userService, $filter, dataConfigService, keycloakService, serviceBase) {
        $scope.updateAccessToken = function() {
            keycloakService.updateAccessToken();
        }

        $scope.redrawTable = function () {
            $rootScope.$broadcast('redrawTable');
        };

        $scope.isActive = function (route) {
            return route === $location.path();
        };

        $scope.isHideControls = function () {
            return $location.path() === '/login';
        };

        $scope.showMyLocation = function () {
            $scope.myLocation = null;
            editService.getMyLocation(function (position) {
                editService.transformCoordinates(position).success(function (coords) {
                    $scope.showDialog(coords);
                });
            });
        };

        $scope.searchStringChange = function() {
            $rootScope.$broadcast('newSearchString', $scope.searchString);
        };

        $scope.$on('searchStringRequest', function() {
            $rootScope.$broadcast('newSearchString', $scope.searchString);
        });

        $scope.$on('openLocationDialog', function($event, coords) {
            $scope.showDialog(coords);
        });

        $scope.showDialog = function (coords) {
            editService.resolveRoad(coords.geometries[0].x, coords.geometries[0].y).success(function (userRoad) {
                $scope.positionOnRoad = userRoad;
                editService.resolveRoadByNumber(userRoad.kelionr).success(function (road) {
                    $rootScope.Ui.turnOn('myLocation');
                    var distanceToRoad = Math.sqrt(Math.pow((coords.geometries[0].x - userRoad.x), 2)
                        + Math.pow((coords.geometries[0].y - userRoad.y), 2));

                    if (distanceToRoad < 150) {
                        $scope.myLocation = {
                            kelioId: road[0].id,
                            kelioPavadinimas: road[0].pavadinimas,
                            kelioNumeris: road[0].numeris,
                            kelias: road[0].numeris + ' ' + road[0].pavadinimas,
                            kmNuo: parseFloat(userRoad.km.toFixed(3)),
                            km: $filter('number')(userRoad.km, 2) + ' km',
                            keliokryptis: userRoad.keliokryptis == 'AB' ? 'Abiem' :
                                (userRoad.keliokryptis == 'PR' ? 'Pirmyn' : (userRoad.keliokryptis == 'AT' ? 'Atgal' : '')),
                            distanceToRoad: Math.round(distanceToRoad) + 'm',
                            x: parseFloat(userRoad.x.toFixed(2)),
                            y: parseFloat(userRoad.y.toFixed(2)),
                            canCreateNew: true
                        };
                    } else {
                        $scope.myLocation = {
                            kelias: '-',
                            km: '-',
                            keliokryptis: '-',
                            distanceToRoad: 'Aplink nėra valstybinės reikšmės kelio',
                            x: coords.geometries[0].x,
                            y: coords.geometries[0].y,
                            canCreateNew: false
                        };
                    }

                    editService.resolveAddress($scope.myLocation.x, $scope.myLocation.y).success(function (addresses) {
                        var nearest = { distance: Number.MAX_VALUE };
                        angular.forEach(addresses.response.docs, function (address) {
                            if (address.distance && address.distance < nearest.distance) {
                                nearest = address;
                            }
                        });
                        $scope.myLocation.adresas = nearest.name + ' ' + nearest.description;
                    });
                    ArcGISMap.showMyLocation(coords.geometries[0].x, coords.geometries[0].y);
                });
            });
        };

        $scope.clearMyLocation = function () {
            ArcGISMap.hideMyLocation();
        }

        $scope.setObjectData = function () {
            $scope.myLocation.xnuo = $scope.myLocation.x;
            $scope.myLocation.ynuo = $scope.myLocation.y;
            ArcGISMap.hideMyLocation();
            editService.obj = $scope.myLocation;
        }

        $scope.exportPdf = function() {
            /* eslint-disable camelcase */
            DataService.downloadFilePost(
                serviceBase + '/reports',
                'defektai.pdf',
                { p_report_name: 'defektai', p_app_name: 'defects', p_defs: getDefectIds() }
            );
        }

        $scope.exportCsv = function () {
            return DataService.getCSV($scope.searchString);
        };

        $scope.exportXlsx = function () {
            /* eslint-disable camelcase */
            DataService.downloadFilePost(
                serviceBase + '/reports',
                'defektai.xlsx',
                { p_report_name: 'defektai_excel', p_app_name: 'defects', p_defs: getDefectIds() }
            );
        };

        function getDefectIds() {
            var data = $filter('filter')(DataService.getData(), function(element) { return DataService.filterData(element, $scope.searchString); });
            var selectedRecsArray = $filter('filter')(data, function(element) { return element.selectedRec == true });
            if (selectedRecsArray.length > 0) {
                data = selectedRecsArray;
            }
            data = $filter('orderBy')(data, dataConfigService.getOrder());
            var defectIds = '';
            _.forEach(data, function (item, index) {
                if (index > 0) {
                    defectIds += ',';
                }
                defectIds += item.id
            });
            return defectIds;
        }

        $scope.hasRole = function (role) {
            return userService.getPermissions()[role];
        };

        $scope.hasAnyRole = function (roles) {
            return _.find(roles, function (role) {
                return $scope.hasRole(role);
            }) ? true : false;
        };
    }
})();
